import React from 'react';
import { REDUCER_NAME } from '../reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import TablePutThrough from './TablePutThrough';
import { I18n } from 'react-redux-i18n';

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listDataRealTimePutThrough: state[REDUCER_NAME].listDataRealTimePutThrough,
    listPutThroughUpcom: state[REDUCER_NAME].listPutThroughUpcom,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TablePutThroughUpcom);

function TablePutThroughUpcom(props) {
  const { listDataRealTimePutThrough, listPutThroughUpcom } = props;
  const realTimeData = listDataRealTimePutThrough.UpcomIndex;
  return (
    <TablePutThrough
      {...props}
      realTimeData={realTimeData}
      data={listPutThroughUpcom}
      name={I18n.t(`watchListSummary.listTitleTablePutThrough.upcom`)}
    />
  );
}
